///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../filter-templates/point-promotions.filter.ts"/>
///<reference path="../collections/report-location-groups.collection.ts"/>


module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;

    export class ReportLocationGroupsDataTemplate extends DataTemplateBase implements IDataTemplate {

        protected locationGroups: ReportLocationGroupsCollection;

        public title: string;
        public allSelectedLabel: string;
        public totalSelectedMessage: string;

        get collection() {
            return this.locationGroups;
        }

        constructor(model: Dictionary<any>, properties: string[], { criteria }) {
            super(model, properties, criteria);

            this.locationGroups = new ReportLocationGroupsCollection(this.model[properties[0]], [], {
                criteria
            });

            this.title = 'LABEL_LOCATION_GROUP';
            this.allSelectedLabel = 'LABEL_ALL_LOCATIONS_GROUPS';
            this.totalSelectedMessage = 'LABEL_TOTAL_LOCATIONS_GROUPS_SELECTED';
        }
    }
}
